import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

<ResponsiveAppBar />

     <main>
     
             <Container maxWidth="lg" className="subPageContainer">
     
               <Typography variant='h1' className='sectionTitle'>Unternehmen</Typography>
     
               <Box className='subpageBodyBox'>
     
                 <Typography variant='h2' className='sectionTitle2 subsection'>Unternehmen gründen</Typography>
                 <Typography variant='body1' className='sectionText textTwoColumns'>
                 Wer ein Unternehmen gründet, muss sich vor allem überlegen, welche Rechtsform am besten zu ihm passt. Die meisten Gründer wählen die Gesellschaft mit beschränkter Haftung (GmbH), weil nur die GmbH für Schulden des Unternehmens haftet. Die Gläubiger der GmbH können nicht auf das Privatvermögen des Unternehmensinhabers zugreifen. Zur Gründung der GmbH müssen der oder die Gründer einen notariell beurkundeten Gesellschaftsvertrag schließen. Der Notar berät zu der genauen Ausgestaltung des Gesellschaftsvertrages und belehrt über wichtige Rechtsfolgen der Gründung. Außerdem übernimmt er die Anmeldung der neu gegründeten GmbH beim Handelsregister. 
                 </Typography>
                 <Button className='btnSecondary'><HashLink smooth to="#">Unternehmen online gründen</HashLink></Button>
               </Box>
     
               <hr className='hoeizontalLine' />
     
               <Box className='subpageBodyBox'>
                 <Typography variant='h2' className='sectionTitle2 subsection'>Unternehmen verkaufen</Typography>
                 <Typography variant='body1' className='sectionText textTwoColumns'>
                 Wer sein Unternehmen verkaufen will, sollte sich angesichts der viele rechtlichen und steuerlichen Folgen unbedingt beraten lassen. Wer eine GmbH verkaufen will, muss den Kaufvertrag zwingend bei einem Notar beurkunden lassen. Der Notar gestaltet den Kaufvertrag so, dass er einen fairen Ausgleich der Interessen von Käufer und Verkäufer schafft. Außerdem überwacht er die Zahlung des Kaufpreises und nimmt Anmeldungen zum Handelsregister vor. Zugleich kann der Notar die Abstimmung mit dem Steuerberater übernehmen. 
                 </Typography>
                 <Button className='btnSecondary'><HashLink smooth to="#">Unternehmensverkauf online abwickeln</HashLink></Button>
               </Box>
     
               <hr className='hoeizontalLine' />
     
               <Box className='subpageBodyBox'>
                 <Typography variant='h2' className='sectionTitle2 subsection'>Unternehmen umwandeln</Typography>
                 <Typography variant='body1' className='sectionText textTwoColumns'>
                 Aus verschiedenen Gründen kann es sinnvoll sein, ein Unternehmen neu zu strukturieren. Beispielsweise können zwei Gesellschaften miteinander verschmelzen, sodass nur noch eine Gesellschaft Inhaberin der Rechte und Pflichten beider vormaligen Gesellschaften ist. Oder das Unternehmen muss seine Rechtsform wechseln, weil es sich gegen bestimmte rechtliche Risiken schützen will. Bei diesen Umwandlungsmaßnahmen berät sie der Notar, beurkundet die jeweiligen Vorgänge und nimmt die Anmeldung beim Handelsregister vor. Steuerliche Fragen kann er unmittelbar mit dem Steuerberater klären. 
                 </Typography>
                 <Button className='btnSecondary'><HashLink smooth to="#">Unternehmen online umwandeln</HashLink></Button>
               </Box>

               <hr className='hoeizontalLine' />
               
               <Box className='subpageBodyBox'>
                 <Typography variant='h2' className='sectionTitle2 subsection'>Unternehmen beenden</Typography>
                 <Typography variant='body1' className='sectionText textTwoColumns'>
                 Wer sein Unternehmen beenden will, muss dafür ein sog. Liquidationsverfahren durchlaufen. Im Rahmen dieses Verfahrens wird das vorhandene Unternehmensvermögen verkauft und damit zu Geld gemacht. Aus dem gewonnenen Geldvermögen muss der Unternehmensinhaber die Forderungen von Gläubigern des Unternehmens erfüllen. Erst nachdem alle Forderungen beglichen sind, kann der Unternehmensinhaber das restliche Vermögen für sich selbst vereinnahmen. Der Notar berät sie zur Gestaltung und den Folgen der Liquidation. Er bereitet auch die erforderlichen Anmeldungen zum Handelsregister vor. 
                 </Typography>
                 <Button className='btnSecondary'><HashLink smooth to="#">Unternehmen online beenden</HashLink></Button>
               </Box>
     
             </Container>
     
     
             <Box className="section bannergrey" id="kontakt">
               <Container maxWidth="lg" className="container" id="kontakt">
                 <Box className="kontaktGrid">
                   <Box className="kontaktLeftSide">
                     <Typography variant='h2' className='sectionTitle white'>
                       Sie haben Fragen?  <br />
                       Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                     </Typography>
                     <Typography variant='body1' paragraph className='whiteText'>
                       Harbecke & Thelen Notare<br />
                       Holzgasse 29 - 33<br />
                       Siegburg 53721<br />
                     </Typography>
                   </Box>
                   <Contactform />
                 </Box>
               </Container>
             </Box>
     
     
           </main >
           <Footer />
    </div >
  );
}

export default Imprint;